import * as tslib_1 from "tslib";
import { EventEmitter, ViewContainerRef } from '@angular/core';
import { util } from '../../classes/util';
import { BaseComponent } from '../base.component';
var ScopeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ScopeComponent, _super);
    function ScopeComponent(vcr) {
        var _this = _super.call(this, vcr) || this;
        _this.register = new EventEmitter();
        _this.unregister = new EventEmitter();
        _this.componentsByTag = {};
        /**
         * In order to detect timing issues, this keeps track of when a request for a component
         * returns a default value that was not explicitly requested (either by ID or through the defaults object).
         *
         * The first time a default is returned, this flag gets set to true for that tag. If new elements are registered after
         * a non-explicitly-requested default is returned, an exception will be thrown.
         */
        _this.defaultWasReturned = {};
        /**
         * Register a child with this scope for other siblings to access.
         * This should only be called by child mc-map components.
         * You can pass any component into this function will no ill-effects;
         * this function will only actually "register" the component types it is looking for.
         */
        _this.registerComponent = function (component) {
            var e_1, _a;
            var tagName = component.hostElement.tagName.toLowerCase();
            var container = _this.componentsByTag[tagName];
            if (!container) {
                container = _this.componentsByTag[tagName] = [];
            }
            // if the component is already registered, log a warning and exit (everything will still work, but developers should fix it)
            if (container.indexOf(component) > -1) {
                console.warn('Component is already registered with scope', component, _this);
                return;
            }
            container.push(component);
            // if more than one component with same tag are registered, verify they all have an id
            if (container.length > 1) {
                // if a default was already returned, hard-fail here...the developer will need to target their components by ID
                if (_this.defaultWasReturned[tagName]) {
                    throw new Error("Cannot register another instance of <" + tagName + "> because a default was already returned. " +
                        ("Since there are more than one isntance of <" + tagName + "> in this scope, you will need to either ") +
                        ("set the \"defaults\" property on <mc-scope>, or update every element that references a <" + tagName + "> ") +
                        ("in this scope to specify a \"" + tagName + "-id\" attribute. This is enforced to prevent unintended timing issues."));
                }
                try {
                    for (var container_1 = tslib_1.__values(container), container_1_1 = container_1.next(); !container_1_1.done; container_1_1 = container_1.next()) {
                        var containerComponent = container_1_1.value;
                        if (util.isEmptyUnsetOrWhitespace(containerComponent.hostElement.id)) {
                            throw new Error("Every <" + tagName + "> component must have an ID when more than one instance is located within an <mc-scope> component");
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (container_1_1 && !container_1_1.done && (_a = container_1.return)) _a.call(container_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            _this.register.emit({ tagName: tagName, component: component });
        };
        /**
         * Unregister a component from mc-scope.
         */
        _this.unregisterComponent = function (component) {
            var tagName = component.hostElement.tagName;
            var container = _this.componentsByTag[tagName.toLowerCase()];
            // fall back to empty array to simplify logic below
            container = container ? container : [];
            // remove this component if registered
            var idx = container.indexOf(component);
            if (idx >= 0) {
                container.splice(idx, 1);
                _this.unregister.emit({
                    component: component,
                    tagName: tagName
                });
            }
            else {
                var idText = util.isEmptyUnsetOrWhitespace(component.hostElement.id) ? " with id " + component.hostElement.id : '';
                throw new Error("Cannot unregister <" + tagName + ">" + idText + " from <mc-scope> because it was never registered.");
            }
        };
        /**
         * Get the desired component from scope
         * If ID is present, find the component with that ID or fail if not registered.
         * If ID is NOT present, find the default component with that tag name.
         * If a default ID for a tag is specified, that ID is used. If not,
         * then if a single component of this tag exists, use that. If no default
         * component could be found, an error is thrown.
         *
         * This method will wait for a component to register, or timeout after `maxTimeoutMilliseconds`.
         * There is no polling, but instead it uses eventEmitter subscriptions, so this should resolve as fast
         * as technically possible.
         */
        _this.getComponent = function (tagName, id, maxTimeoutMilliseconds) {
            if (maxTimeoutMilliseconds === void 0) { maxTimeoutMilliseconds = 5000; }
            return new Promise(function (resolve, reject) {
                // try to get the component right now
                var result = _this._getComponent(tagName, id);
                if (result.component) {
                    resolve(result.component);
                    return;
                }
                else if (result.canRetry) {
                    var subscription_1;
                    // after a timeout, if we still don't have the component, hard-fail
                    var removeTimeout_1 = util.timeout(function () {
                        //remove the subscription
                        subscription_1.unsubscribe();
                        var idText = id ? ", \"" + id + "\"" : '';
                        //reject the promise because we have not seen the component we want within the allotted time.
                        reject("Exceeded maximum wait time of " + maxTimeoutMilliseconds + "ms for `getComponent(\"" + tagName + "\"" + idText + ").`: " + result.error);
                    }, maxTimeoutMilliseconds);
                    // wait for a new component to be registered, and if it maches, great.
                    subscription_1 = _this.register.subscribe(function (item) {
                        if (item.tagName === tagName) {
                            result = _this._getComponent(tagName, id);
                            if (result.component) {
                                // we found a result, use it and clean up
                                resolve(result.component);
                                subscription_1.unsubscribe();
                                removeTimeout_1();
                            }
                        }
                    });
                }
            });
        };
        _this.registerEvent('onregister', _this.register);
        _this.registerEvent('onunregister', _this.unregister);
        return _this;
    }
    Object.defineProperty(ScopeComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScopeComponent.prototype, "includeEsriCss", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScopeComponent.prototype, "includeOverrideCss", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    /**
     * Internal call to get a component immediately. If the component hasn't registered yet, it will return a null component.
     * If you want to wait for the component to eventually register, you should call `getComponent` (without underscore)
     */
    ScopeComponent.prototype._getComponent = function (tagName, id) {
        var targetId = !util.isEmptyUnsetOrWhitespace(id) ? id : this.getAttributeValue("default-" + tagName + "-id");
        var container = this.componentsByTag[tagName.toLowerCase()];
        container = container ? container : [];
        // if we have an ID specified, then find that component or fail
        if (!util.isEmptyUnsetOrWhitespace(targetId)) {
            var targetComponent = container.filter(function (x) { return x.hostElement.id === targetId; })[0];
            if (!targetComponent) {
                return {
                    canRetry: true,
                    component: null,
                    error: "Cannot find a <" + tagName + "> component with id \"" + targetId + "\" registered in this <mc-scope> component"
                };
            }
            else {
                return {
                    canRetry: false,
                    component: targetComponent
                };
            }
        }
        // if we have exactly one of the items registered
        if (container.length === 1) {
            this.defaultWasReturned[tagName] = true;
            return {
                canRetry: true,
                component: container[0]
            };
        }
        else if (container.length === 0) {
            return {
                canRetry: true,
                component: null,
                error: "No <" + tagName + "> components are registered within <mc-scope>, so no default could be loaded"
            };
        }
        else {
            return {
                canRetry: false,
                component: null,
                // more than 1 component registered, hard-fail because we couldn't find a default
                error: "Cannot determine the default <" + tagName + "> component because there are multiple <" + tagName + "> components registered within this <mc-frame>. Please specify the id of the <" + tagName + "> component you wish to reference."
            };
        }
    };
    return ScopeComponent;
}(BaseComponent));
export { ScopeComponent };
